import ApiService from './ApiService';

const API_URLS = window.AppConfig.API_URLS;

export default class NotificationService {

    static async getLogs(userId, queryUrl) {
        return ApiService.GetData(`${API_URLS.NOTIFICATION_LOGS}/${userId}${queryUrl}`);
    }

    static async getAllEmailTemplates(tenantId, queryUrl) {
        return ApiService.GetData(`${API_URLS.NOTIFICATION}/${API_URLS.TENANTS}/${tenantId}/${API_URLS.EMAIL_TEMPLATE}${queryUrl}`);
    }

    static async getAllSmsTemplates(tenantId, queryUrl) {
        return ApiService.GetData(`${API_URLS.NOTIFICATION}/${API_URLS.TENANTS}/${tenantId}/${API_URLS.SMS_TEMPLATE}${queryUrl}`);
    }

    static async updateEmailTemplate(tenantId, requestBody) {
        return ApiService.PatchData(`${API_URLS.NOTIFICATION}/${API_URLS.TENANTS}/${tenantId}/${API_URLS.EMAIL_TEMPLATE}`, requestBody);
    }

    static async updateSmsTemplate(tenantId, requestBody) {
        return ApiService.PatchData(`${API_URLS.NOTIFICATION}/${API_URLS.TENANTS}/${tenantId}/${API_URLS.SMS_TEMPLATE}`, requestBody);
    }

    static async getOneEmailTemplates(tenantId, key, locale) {
        return ApiService.GetData(`${API_URLS.NOTIFICATION}/${API_URLS.TENANTS}/${tenantId}/${API_URLS.EMAIL_TEMPLATE}/${key}/${locale}`);
    }

    static async getOneSmsTemplates(tenantId, key, locale) {
        return ApiService.GetData(`${API_URLS.NOTIFICATION}/${API_URLS.TENANTS}/${tenantId}/${API_URLS.SMS_TEMPLATE}/${key}/${locale}`);
    }

}
